import {FC, useEffect, useRef, useState} from "react";
import "./CustomDropdown.css";
import {ISelectOptions} from "../components/ClusterFilter/types";
import IconArrowDown from "../assets/icons/arrow-down.svg";
import {IEsgFilters} from "../pages/Esg/EsgDashboard.type";
import {IconContainer} from "../components/ClusterFilter/styles";
import {Dropdown} from "react-bootstrap";
import {IStateInitiativeFilters} from "../pages/StateInitiative/StateInitiative.type";
import {ITypeRadar} from "../types";

interface IProps {
  onFilterChange: <T>(filter: string, value?: T) => void;
  title?: string;
  idSelect?: string;
  filters: IEsgFilters | IStateInitiativeFilters;
  selectOptions?: ISelectOptions[];
  typeRadar?: ITypeRadar;

  isResetFilters?: boolean;
  setIsResetFilters?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MySelect: FC<IProps> = ({
  onFilterChange,
  title,
  idSelect: idSelectFilter,
  filters,
  selectOptions,
  typeRadar,
  isResetFilters,
  setIsResetFilters,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [selectedOption, setSelectedOption] = useState<ISelectOptions>(() => {
    if (typeRadar === "stateInitiative") {
      return {value: "", label: "Все"};
    }

    if (!idSelectFilter || !filters[idSelectFilter as keyof typeof filters]) {
      return {value: "", label: ""};
    }

    const filterValue = filters[idSelectFilter as keyof typeof filters] as any;

    // Получаем значение из фильтра (может быть id или value)
    const valueToMatch = filterValue?.id ?? filterValue?.value ?? "";

    const foundOption = selectOptions?.find(
      (item) => item.value === valueToMatch
    );

    return {
      value: foundOption?.value ?? "",
      label: foundOption?.label ?? "",
    };
  });

  useEffect(() => {
    if (isResetFilters) {
      setSelectedOption({value: "", label: "Все"});
    }
  }, [isResetFilters]);

  const handleSelectChange = ({value, label}: ISelectOptions) => {
    setSelectedOption((prev) => ({...prev, value, label}));
    if (idSelectFilter) onFilterChange(idSelectFilter, value);
    if (setIsResetFilters) setIsResetFilters(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const isActive = selectedOption.label !== "Все";
  return (
    <IconContainer
      ref={ref}
      onClick={() => setIsOpen(!isOpen)}
      isActive={isActive}
    >
      {/* <DropdownButton
        title={
          <div>
            <span style={{color: "#ccc"}}>{firstOption} </span>
            {selectedOption.label}
          </div>
        }
        className="custom-dropdown-button"
      >
        {selectOptions &&
          selectOptions?.map((option, index) => (
            <Dropdown.Item
              key={option.value}
              onClick={() => handleSelectChange(option)}
            >
              <div className="custom-form-control-label">{option.label}</div>
            </Dropdown.Item>
          ))}
      </DropdownButton> */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* <span style={{color: "#ccc"}}>{firstOption} </span> */}
        {selectedOption.label}
        <img src={IconArrowDown} alt="arrow" />
      </div>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 60,
            padding: "8px 16px",
            borderRadius: "12px",
            border: "1px solid rgba(246, 251, 253, 0.2)",
            background: "#161A1D",
            color: "rgba(255, 255, 255, 0.7)",
            zIndex: 10,
          }}
        >
          {selectOptions &&
            selectOptions?.map((option, index) => (
              <Dropdown.Item
                key={option.value}
                onClick={() => handleSelectChange(option)}
              >
                <div className="custom-form-control-label">{option.label}</div>
              </Dropdown.Item>
            ))}
        </div>
      )}
    </IconContainer>
  );
};
